export default __webpack_public_path__ + "static/media/bakeli school.35ede255.mp4";